import { render, staticRenderFns } from "./task-el.vue?vue&type=template&id=441031ea&scoped=true"
import script from "./task-el.vue?vue&type=script&lang=js"
export * from "./task-el.vue?vue&type=script&lang=js"
import style0 from "./task-el.vue?vue&type=style&index=0&id=441031ea&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441031ea",
  null
  
)

export default component.exports